import { render, staticRenderFns } from "./crewMemberDetail.vue?vue&type=template&id=78fe0d7d&scoped=true"
import script from "./crewMemberDetail.vue?vue&type=script&lang=js"
export * from "./crewMemberDetail.vue?vue&type=script&lang=js"
import style0 from "./crewMemberDetail.vue?vue&type=style&index=0&id=78fe0d7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe0d7d",
  null
  
)

export default component.exports